import React, { useEffect, useState } from 'react';
import useAxios from '../hook/useAxios';
import useRouter from '../hook/useRouter';

export interface ICategoryProp {
    watchD1: string;
    watchD2: string;
    submitCallback: (d1: string, d2: string) => void;
    title: string;
    config: { locale: string; apiDomain: string };
    path: string;
    l10n: { [key: string]: string };
    ga360str: string;
}

export interface ICategoryData {
    id: string;
    name: string;
    child: {
        id: string;
        name: string;
    }[];
}

export const Category = ({ props }: { props: ICategoryProp }) => {
    const { watchD1, watchD2, title, config, path, l10n, submitCallback, ga360str } = props;
    const { params, getValue, changeParam } = useRouter([props.watchD1, props.watchD2]);
    const { res, loading, fetchData } = useAxios<ICategoryData[]>();
    const [dat, datSet] = useState<ICategoryData[]>([]);
    const [depth, depthSet] = useState<{ d1: string | null; d2: string | null }>({ d1: null, d2: null });

    useEffect(() => {
        fetchData({ config: config, method: 'get', path: path, l10n: l10n });
    }, []);

    useEffect(() => {
        if (!res) return;
        datSet(res);
    }, [res]);

    useEffect(() => {
        if (!params) return;
        const d1 = getValue(watchD1) || '';
        const d2 = getValue(watchD2) || '';
        depthSet({ d1: d1, d2: d2 });
    }, [params]);

    const onClickCategory = (e: React.MouseEvent<HTMLButtonElement>) => {
        const targ = e.currentTarget as HTMLElement;
        let d1 = targ.dataset.d1 || '';
        let d2 = targ.dataset.d2 || '';
        changeParam({ [watchD1]: d1, [watchD2]: d2, page: '' });
        submitCallback(d1, d2);
    };

    return (
        <section className="category">
            <header>{title}</header>
            <article>
                <button className="btn-category" data-d1="" data-d2="" onClick={onClickCategory}>
                    {l10n['common.all']}
                </button>
                <ul>
                    {dat.map((it, idx) => (
                        <li data-dep={it.id} key={'cate' + idx} className={it.id === depth.d1 ? 'is-active' : ''}>
                            <button
                                className="btn-category"
                                data-d1={it.id}
                                data-areas="시세_조건검색_카테고리_클릭"
                                data-contents={it.name}
                                onClick={onClickCategory}
                            >
                                {it.name}
                            </button>
                            <ul>
                                {it.child.map((sub, subidx) => (
                                    <li
                                        data-dep={`${it.id}-${sub.id}`}
                                        key={'cate' + idx + subidx}
                                        className={it.id === depth.d1 && sub.id === depth.d2 ? 'is-active' : ''}
                                    >
                                        <button
                                            className="btn-category"
                                            data-d1={it.id}
                                            data-d2={sub.id}
                                            data-areas={ga360str}
                                            data-contents={`${it.name}-${sub.name}`}
                                            onClick={onClickCategory}
                                        >
                                            {sub.name}
                                        </button>
                                        {/* <button className="btn-category" data-d1={it.id} data-d2={sub.id} data-areas="시세_조건검색_카테고리_클릭" data-contents={`${it.name}-${sub.name}`} onClick={onClickCategory}>{sub.name}</button> */}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </article>
        </section>
    );
};
